import { FC } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import Button from "Components/UI/Button";
import Modal from "Components/UI/Modal";
import { Icon } from "Components/UI";
import {
  BtnContainer,
  Container,
  Content,
  Title,
} from "./styles";

interface IPhaseNomenclatura {
  visible: boolean;
  active?: boolean;
  loading?: boolean;
  isDefault?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const PhaseNomenclatura: FC<IPhaseNomenclatura> = ({
  visible,
  active,
  loading,
  isDefault,
  onConfirm,
  onCancel,
}) => {
  const handleConfirm = () => {
    onConfirm();
    onCancel();
  }

  return (
    <Modal
      visible={visible}
      width={450}
      footerButtons={null}
    >
      <Container>
        <Title>
          <span className="textTitle">
            {`${active ? 'Desativar' : 'Ativar'} validação de etapas na nomenclatura?`}
          </span>
        </Title>

        <Content>
          <span className="contentText">
            {active
              ? 'Você tem certeza que deseja desativar a validação de etapas na nomenclatura? Isso fará com que qualquer valor seja preenchido no campo de “Etapa” na nomenclatura dos arquivos.'
              : 'Você tem certeza que deseja ativar a validação de etapas na nomenclatura? Isso fará com que todos os arquivos já enviados e que serão enviados tenham as etapas da nomenclatura correspondente às etapas cadastradas.'
            }
          </span>
          {active && (
            <span className="contentText">
              As etapas ainda irão aparecer na edição de nomenclatura, mas não será obrigatório a seleção de uma etapa da lista.
            </span>
          )}
          {!active && (
            <span className="warningBox">
              <Icon
                icon="alerta"
                customSize={16}
                className="alertIcon"
              />
              <span className="alertText">
                Essa ação pode ocasionar a invalidação da nomenclatura de arquivos que não tenham o campo de etapa correspondente com o cadastro de etapas.
              </span>
            </span>
          )}
        </Content>

        <BtnContainer>
          <Button type="text" className="cancelBtn" onClick={onCancel}>
            Cancelar
          </Button>
          {!isDefault && (
            <Button
              type="primary"
              className="deleteBtn"
              onClick={handleConfirm}
              primaryDanger={active}
            >
              {loading && (
                <Spin
                  indicator={
                    <LoadingOutlined
                      color="white"
                      style={{ fontSize: 12, color: 'white', marginRight: 6 }}
                    />
                  }
                />
              )}
              {active && (loading ? 'Desativando...' : 'Desativar')}
              {!active && (loading ? 'Ativando...' : 'Ativar')}
            </Button>
          )}
        </BtnContainer>
      </Container>
    </Modal>
  )
}

export default PhaseNomenclatura;
